export default __webpack_public_path__ + "static/media/tabs-profile.4c55894c.svg";